"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "mis": 4290,
    "mul": 4579,
    "und": 7098,
    "zxx": 8232
};
//# sourceMappingURL=special.json.js.map